"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_OAUTH_CLIENT_ID = void 0;
// ID copied from https://console.cloud.google.com/apis/credentials?project=soki-300523
exports.GOOGLE_OAUTH_CLIENT_ID = "680424354121-2rb1p9iha7pc3pcumip1k2548dgodbni.apps.googleusercontent.com";
